/**
 * ChartLegend — horizontal row of colored swatches + labels used at the
 * bottom of stacked-bar / multi-series widgets. Matches the Penpot
 * "Requests By Type" legend (8×8 rounded square + 9px Work Sans label,
 * 4-item gap row).
 */

import * as React from "react";
import { formatRgb } from "./types";

export interface ChartLegendItem {
  key: string | number;
  label: string;
  color?: string | null;
}

export interface ChartLegendProps {
  items: ChartLegendItem[];
  /** Swatch size in px (default 8). */
  swatchSize?: number;
  className?: string;
}

export function ChartLegend({ items, swatchSize = 8, className = "" }: ChartLegendProps) {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 ${className}`}>
      {items.map((item) => (
        <span key={item.key} className="inline-flex items-center gap-1.5">
          <span
            aria-hidden
            className="inline-block rounded-sm flex-shrink-0"
            style={{
              width: swatchSize,
              height: swatchSize,
              backgroundColor: formatRgb(item.color),
            }}
          />
          <span className="text-[9px] text-gray-500">{item.label}</span>
        </span>
      ))}
    </div>
  );
}
